/* eslint-disable */
import Vue from 'vue'
import App from '../apps/FlashAlertApp.vue'

new Vue({
  name: 'Flash Alert',
  el: '#flash-alert-vue-target',
  render: h => h(App)
})
